import {
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_RESET,
  UPDATE_PROFILE_FAIL,
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_RESET,
  UPDATE_PASSWORD_FAIL,
  ASSIGN_ROLE_REQUEST,
  ASSIGN_ROLE_SUCCESS,
  ASSIGN_ROLE_RESET,
  ASSIGN_ROLE_FAIL,
  CLEAR_ERRORS,
} from "../constants/userConstants";

export const userReducer = (state = {}, action) => {
  switch (action.type) {
    case UPDATE_PROFILE_REQUEST:
    case UPDATE_PASSWORD_REQUEST:
      return {
        ...state,
        loading: true,
        errors: null,
      };

    case UPDATE_PROFILE_SUCCESS:
    case UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        isUpdated: action.payload,
        errors: null,
      };

    case UPDATE_PROFILE_RESET:
    case UPDATE_PASSWORD_RESET:
      return {
        ...state,
        isUpdated: false,
      };

    case UPDATE_PROFILE_FAIL:
    case UPDATE_PASSWORD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
        errors: action.errors,
      };

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};

export const assignRoleReducer = (state = { isAssigned: false }, action) => {
  switch (action.type) {
    case ASSIGN_ROLE_REQUEST:
      return { loading: true, isAssigned: false, error: null };

    case ASSIGN_ROLE_SUCCESS:
      return { loading: false, isAssigned: true, user: action.payload };

    case ASSIGN_ROLE_RESET:
      return { loading: false, isAssigned: false, user: null, error: null };

    case ASSIGN_ROLE_FAIL:
      return { loading: false, isAssigned: false, error: action.payload };

    case CLEAR_ERRORS:
      return { ...state, error: null };

    default:
      return state;
  }
};
